import { Link } from "react-router-dom";
import styled from "styled-components";
type ImageProps = {
  $img: string;
};

export const PostContainer = styled.div`
  width: 425px;
  @media (max-width: 430px) {
    width: 383px;
    margin-bottom: 50px;
  }
`;
export const TagsContainer = styled.div`
  display: flex;
  gap: 6px;
`;

export const Tags = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  background-color: #bfdcf5;
  border: 1px solid #bfdcf5;
  border-radius: 20px;
  padding: 1px 10px;
  margin-top: 22px;
`;
export const CreatedAt = styled.div`
  margin-top: 26px;
  margin-bottom: 8px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  color: #a7a7a7;
`;
export const Img = styled.div<ImageProps>`
  width: 425px;
  height: 200px;

  @media (max-width: 430px) {
    border-radius: 15px;
    width: 373px;
  }

  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;

export const H1Mobile = styled(Link)`
  display: none;
  font-family: Cormorant Infant;
  font-size: 30px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  color: #141414;

  @media (max-width: 430px) {
    display: block;
  }
`;
export const H1 = styled(Link)`
  display: block;
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  color: #141414;

  @media (max-width: 430px) {
    display: none;
  }
`;
